export const getFormattedContacts = (l, datepipe, contactAssociation) => {

  let EmailHome = '';
  let EmailPersonal = '';
  let EmailWork = '';
  let EmailOther = '';
  let EmailCE1 = '';
  let EmailCE2 = '';
  let Email = '';
  if (l.contactEmails) {
    for (let e of l.contactEmails) {
      if (e.email?.emailType?.name == "Work Email")
        EmailWork = e.email.emailAddress;
      if (e.email?.emailType?.name == "Personal Email")
        EmailPersonal = e.email.emailAddress;
      if (e.email?.emailType?.name == "Home Email")
        EmailHome = e.email.emailAddress;
      if (e.email?.emailType?.name == "Other Email")
        EmailOther = e.email.emailAddress;
      if (e.email?.emailType?.name == "CE1")
        EmailCE1 = e.email.emailAddress;
      if (e.email?.emailType?.name == "CE2")
        EmailCE2 = e.email.emailAddress;
    }
    if (EmailWork != "") { Email = EmailWork }
    else if (EmailPersonal != "") { Email = EmailPersonal }
    else if (EmailHome != "") { Email = EmailHome }
    else if (EmailOther != "") { Email = EmailOther }
    else if (EmailCE1 != "") { Email = EmailCE1 }
    else if (EmailCE2 != "") { Email = EmailCE2 }
  }

  let PhoneWork = { number: '', code: '', extension: '' };
  let PhoneMobile = { number: '', code: '', extension: '' };
  let PhoneHome = { number: '', code: '', extension: '' };
  let PhoneFax = { number: '', code: '', extension: '' };
  let PhoneOther = { number: '', code: '', extension: '' };
  let PhoneMain = { number: '', code: '', extension: '' };
  let PhoneInActive = { number: '', code: '', extension: '' };
  let PhoneCP1 = { number: '', code: '', extension: '' };
  let PhoneCP2 = { number: '', code: '', extension: '' };
  let Phone = { number: '', code: '', extension: '' };

 if (l.contactPhones) {
    for (let p of l.contactPhones) {
      const { number, phoneType, code, extension = '' } = p.phone;
      switch (phoneType?.name) {
        case "Mobile Phone":
          PhoneMobile = { number, code, extension };
          break;
        case "Home Phone":
          PhoneHome = { number, code, extension };
          break;
        case "Work Phone":
          PhoneWork = { number, code, extension };
          break;
        case "Fax":
          PhoneFax = { number, code, extension };
          break;
        case "Other":
          PhoneOther = { number, code, extension };
          break;
        case "Main":
          PhoneMain = { number, code, extension };
          break;
        case "InActive":
          PhoneInActive = { number, code, extension };
          break;
        case "CP1":
          PhoneCP1 = { number, code, extension };
          break;
        case "CP2":
          PhoneCP2 = { number, code, extension };
          break;
      }
    }
    if (PhoneMobile.number) { Phone = PhoneMobile }
    else if (PhoneHome.number) { Phone = PhoneHome }
    else if (PhoneWork.number) { Phone = PhoneWork }
    else if (PhoneFax.number) { Phone = PhoneFax }
    else if (PhoneOther.number) { Phone = PhoneOther }
    else if (PhoneMain.number) { Phone = PhoneMain }
    else if (PhoneInActive.number) { Phone = PhoneInActive }
    else if (PhoneCP1.number) { Phone = PhoneCP1 }
    else if (PhoneCP2.number) { Phone = PhoneCP2 }
  }

  let SocialTwitter = '';
  let SocialFacebook = '';
  let SocialLinkedIn = '';
  let Website = '';
  let Social = '';
  if (l.contactSocialProfiles) {
    for (let s of l.contactSocialProfiles) {
      if (s.socialProfile?.socialProfileType?.name == "Website")
        Website = s.socialProfile.name;
      if (s.socialProfile?.socialProfileType?.name == "Twitter")
        SocialTwitter = s.socialProfile.name;
      if (s.socialProfile?.socialProfileType?.name == "Facebook")
        SocialFacebook = s.socialProfile.name;
      if (s.socialProfile?.socialProfileType?.name == "Linkedin")
        SocialLinkedIn = s.socialProfile.name;
    }
    if (Website != "") { Social = Website }
    else if (SocialTwitter != "") { Social = SocialTwitter }
    else if (SocialFacebook != "") { Social = SocialFacebook }
    else if (SocialLinkedIn != "") { Social = SocialLinkedIn }
  }
  l.dateOfBirth = datepipe.transform(new Date(), 'mm-dd-yyyy');
  l.startDate = datepipe.transform(new Date(), 'mm-dd-yyyy');

  let eachContact = {
    id: l.id,
    sequenceNumber: l?.sequenceNumber,
    firstName: l.firstName,
    lastName: l.lastName,
    fullName: l.name ? l.name : (l.firstName || '') + ' ' + (l.middleName || '') + ' ' + (l.lastName || ''),
    businessName: l.associationName,
    associationId: l.associationId,
    title: l.title,
    source: l.source ? l.source.name : null,
    assignedToUserId: l.assignedToUserId,
    state: l.contactAddresses && l.contactAddresses[0] && l.contactAddresses[0].address && l.contactAddresses[0].address.state && l.contactAddresses[0].address.state.name ? l.contactAddresses[0].address.state.name : "",
    city: l.contactAddresses && l.contactAddresses[0] && l.contactAddresses[0].address && l.contactAddresses[0].address.city && l.contactAddresses[0].address.city.name ? l.contactAddresses[0].address.city.name : null,
    email: Email,
    phone: Phone,
    social: Social,
    birth: l.dateOfBirth,
    gender: l.gender ? l.gender.name : null,
    language: l.contactSpokenLanguages && l.contactSpokenLanguages[0] && l.contactSpokenLanguages[0].language ? l.contactSpokenLanguages[0].language.name : null,
    contactType: l.contactType ? l.contactType.name : null,
    associationName: l.associationName,
    contactAssociation: contactAssociation.length && l.contactAssociationTypeId ? contactAssociation.find(obj => obj.id == l.contactAssociationTypeId)?.name : null,
    contactAssociationId: l.contactAssociationTypeId,
    contactAssociationTypeId: l.contactAssociationTypeId,
    department: l.department,
    relation: l.relationshipStatus ? l.relationshipStatus.name : null,
    marital: l.maritalStatus ? l.maritalStatus.name : null,
    income: l.annualIncome ? l.annualIncome.name : null,
    degree: l.degree ? l.degree.name : null,
    studyField: l.fieldOfStudy ? l.fieldOfStudy.name : null,
    seniority: l.seniority,
    assistantPhone: l.assistantPhone,
    report: l.reportsTo ? l.reportsTo.name : null,
    assistant: l.assistant ? l.assistant.name : null,
    statusId: l.statusId,
    parentChildRelationType: l.parentChildRelationType, 
    designation: l.role?.name || '',
  }

  return eachContact;
}
